import scenarioMgmtSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const scenarioMgmtActions = { ...actions, ...thunkActions };
export * as ScenarioMgmtTypes from './types';
export default scenarioMgmtSlice;
